import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/ui/Icon';
import { ICONS } from '@/constants/icons';
import { focusSurface } from '@/components/ui/focusStyles';

interface DashboardCollapseButtonProps {
  collapsed: boolean;
  onClick: () => void;
}

/** The shared collapse control for dashboard cards. */
export const DashboardCollapseButton = ({ collapsed, onClick }: DashboardCollapseButtonProps) => {
  const { t } = useTranslation('common');

  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-8 h-8 flex items-center justify-center rounded-md text-gray-500 [@media(hover:hover)]:hover:text-primary-600 [@media(hover:hover)]:hover:bg-gray-100 transition-colors ${focusSurface}`}
      aria-label={
        collapsed
          ? t('expand_section', { defaultValue: 'Expand section' })
          : t('collapse_section', { defaultValue: 'Collapse section' })
      }
      aria-expanded={!collapsed}
    >
      <Icon
        name={collapsed ? ICONS.ANGLE_DOWN : ICONS.ANGLE_UP}
        size="sm"
        color="text-gray-600"
        ariaHidden
      />
    </button>
  );
};
